import {fetchPost, generateEndpoint} from "../../../utils/request";

export const createGuest = async({ guest }) => {
  const url = `${generateEndpoint('createGuest')}`
  return fetchPost(url, null, { guest })
}